import Vue from 'vue';
import { VuexBuilder } from '@helpers/vuexBuilder';

const state = {
	initialized: false,
	hasNoOnboarding: false,
	stages: [],
	status: "Pending",
	employeesSeenWelcome: [],
	operations: {
		get: false,
	},
};

const getters = {
	isInitialized: state => state.initialized,
	getStages: state => state.stages,
	numStages: state => state.stages.length,
	numPending: state => state.stages.filter(x => x.status === "Pending").length,
	numCompleted: state => state.stages.filter(x => x.status === "Completed" || x.status === 'Skipped').length,
	hasSeenWelcome: state => id => state.employeesSeenWelcome.includes(id),
	hasNoOnboarding: state => state.hasNoOnboarding
};

const actions = {
	async init({commit, dispatch}) {
		await dispatch('get');
		commit('SET_INITIALIZED');
	},

	async get({ commit, rootState }) {
		return await new VuexBuilder(commit)
			.operationKey("get")
			.request(() => Vue.axios.get(`/api/${rootState.tenantId}/tenantonboarding`))
			.commitData('GET_SUCCESS')
			.execute()
	},

	async updateStatus({dispatch, state}, status) {
		const updateDto = {
			status,
			stages: state.stages,
			employeesSeenWelcome: state.employeesSeenWelcome
		}
		return await dispatch('updateOnboarding', updateDto)
	},

	async setCurrentEmployeeAsSeenWelcome({dispatch, state, rootGetters}) {
		const currentEmployee = rootGetters.loggedInEmployee;

		if (!currentEmployee) return;

		const updateDto = {
			status: state.status,
			stages: state.stages,
			employeesSeenWelcome: Array.from(new Set([...state.employeesSeenWelcome, currentEmployee.id]))
		}

		return await dispatch('updateOnboarding', updateDto);

	},

	async updateStage({dispatch, state}, { type, status }) {
		if (!type || !status) {
			console.error("Did not pass the correct arguments to update stage", { type, status })
		}

		const stages = JSON.parse(JSON.stringify(state.stages));
		const stageIndex = stages.findIndex(x => x.type === type)

		if (stageIndex === -1) return;

		stages[stageIndex].status = status

		let wholeOnboardStatus = state.status;

		if (stages.every(x => x.status === 'Skipped')) {
			wholeOnboardStatus = 'Skipped'
		}
		else if (stages.every(x => x.status === 'Completed' || x.status === 'Skipped')) {
			wholeOnboardStatus = 'Completed'
		}
		else {
			wholeOnboardStatus = 'Pending'
		}

		const updateDto = {
			status: wholeOnboardStatus,
			stages,
			employeesSeenWelcome: state.employeesSeenWelcome
		}

		return await dispatch('updateOnboarding', updateDto)
	},

	async updateOnboarding({commit, rootState}, updateDto) {
		return await new VuexBuilder(commit)
			.operationKey("update")
			.request(() => Vue.axios.put(`/api/${rootState.tenantId}/tenantonboarding`, updateDto))
			.commitData('UPDATE_SUCCESS')
			.execute()
	}
};

const mutations = {
	SET_INITIALIZED(state) {
		state.initialized = true;
	},
	START_OPERATION(state, operationKey) {
		state.operations[operationKey] = true
	},
	FINISH_OPERATION(state, operationKey) {
		state.operations[operationKey] = false
	},
	GET_SUCCESS(state, data) {
		if (!data) {
			state.hasNoOnboarding = true;
			return;
		}
		state.status = data.status;
		state.stages = data.stages;
		state.employeesSeenWelcome = data.employeesSeenWelcome
	},
	UPDATE_SUCCESS(state, data) {
		state.status = data.status;
		state.stages = data.stages;
		state.employeesSeenWelcome = data.employeesSeenWelcome
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
